import React from 'react'

const NavigationButtons = ({
  currentStep,
  onBack,
  onContinue,
  isContinueDisabled,
  saving,
  checkingServiceability,
}) => (
  <div className="flex gap-2">
    {currentStep > 0 && (
      <button
        type="button"
        className="btn-neutral btn-base-large btn-inline-block text-base-gray-text-secondary"
        onClick={onBack}
        disabled={saving}
      >
        <hero-icon-outline name="arrow-left" class="h-4 w-4 text-base-gray-text-secondary" />
        <span className="text-base font-medium">Back</span>
      </button>
    )}
    <button
      type="button"
      className='btn-blue-main btn-base-large btn-inline-block'
      disabled={isContinueDisabled || saving}
      onClick={onContinue}
    >
      <span className="text-base font-medium">
        {saving
          ? (checkingServiceability ? 'Checking...' : 'Submitting...')
          : 'Continue'}
      </span>
      <span className={`spinner-icon white-spinner flex-shrink-0 ${saving ? '' : 'invisible'}`} />
      <hero-icon-outline
        name="arrow-right"
        class={`h-4 w-4 text-surface flex-shrink-0 ${saving ? 'invisible' : ''}`}
      />
    </button>
  </div>
)

export default NavigationButtons
